// A entidade privada só deve ser ativada após validar as permissões no Lumi.
export const emptyCurriculo = () => ({
  areasAtuacao: [] as string[], telefone: '', emailContato: '', cidade: '', nacionalidade: '',
  documentacao: '', linkedin: '', portfolio: '', objetivo: '', experiencias: [] as any[],
  formacoes: [] as any[], idiomas: [] as any[], habilidades: [] as string[], certificacoes: [] as any[],
  disponibilidade: '', disponibilidadeViagem: false, cnh: false, referencias: '', altura: '',
});
export type Curriculo = ReturnType<typeof emptyCurriculo>;
export function normalizeCurriculo(value: unknown): Curriculo {
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Currículo inválido.');
  const input = value as Record<string, unknown>;
  const result = emptyCurriculo();
  for (const key of Object.keys(result) as (keyof Curriculo)[]) {
    const v = input[key];
    const original = result[key];
    if (v === undefined) continue;
    if (Array.isArray(original)) {
      if (!Array.isArray(v)) throw new Error('Dados do currículo inválidos.');
      const strings = key === 'areasAtuacao' || key === 'habilidades';
      if (v.length > 100 || v.some(item => strings ? typeof item !== 'string' : !item || typeof item !== 'object' || Array.isArray(item))) throw new Error('Lista do currículo inválida.');
      (result as any)[key] = v;
    } else if (typeof v === typeof original) (result as any)[key] = v;
    else throw new Error('Dados do currículo inválidos.');
  }
  return result;
}
export function createCurriculoStore(options: { cloud: boolean; storage: Storage; entity: any }) {
  const key = (id: string) => {
    if (!id) throw new Error('Entre na sua conta para salvar o currículo.');
    return `bbqjobs:curriculo:v1:${id}`;
  };
  return {
    async load(id: string): Promise<Curriculo | null> {
      const storageKey = key(id);
      if (!options.cloud) {
        const raw = options.storage.getItem(storageKey);
        return raw ? normalizeCurriculo(JSON.parse(raw).dados) : null;
      }
      const { list } = await options.entity.list({ filter: { userId: id }, limit: 2 });
      if (list?.length > 1) throw new Error('Há currículos duplicados. Solicite a revisão do cadastro.');
      if (!list?.length) return null;
      if (list[0].userId !== id) throw new Error('Currículo não autorizado.');
      return normalizeCurriculo(list[0].dados);
    },
    async save(id: string, value: Curriculo): Promise<void> {
      const storageKey = key(id);
      const dados = normalizeCurriculo(value);
      const now = new Date().toISOString();
      if (!options.cloud) {
        options.storage.setItem(storageKey, JSON.stringify({ version: 1, dados, updatedAt: now }));
        return;
      }
      const { list } = await options.entity.list({ filter: { userId: id }, limit: 2 });
      if (list?.length > 1) throw new Error('Há currículos duplicados. Solicite a revisão do cadastro.');
      if (list?.length) {
        if (list[0].userId !== id) throw new Error('Currículo não autorizado.');
        await options.entity.update(list[0]._id, { dados, updatedAt: now });
      } else await options.entity.create({ userId: id, dados, creator: id, createdAt: now, updatedAt: now });
    },
    removeLocal(id: string) { options.storage.removeItem(key(id)); },
  };
}

// An application receives a fixed professional copy, not access to the private CV record.
export function serializeApplicationCurriculo(value: Curriculo): string {
  const { objetivo, experiencias, formacoes, idiomas, habilidades, certificacoes, areasAtuacao, disponibilidade, cidade, emailContato, telefone, linkedin, portfolio } = normalizeCurriculo(value);
  return JSON.stringify({ objetivo, experiencias, formacoes, idiomas, habilidades, certificacoes, areasAtuacao, disponibilidade, cidade, emailContato, telefone, linkedin, portfolio });
}
